import { useLocation } from 'react-router-dom'
import useFilters from '../../../hook/useFilters'
import useApi from '../../../services/useApi'
import {dataToCostAnalysisReportList} from '../utils'

const useGetCostAnalysisReportList = () => {
  const Api = useApi()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)

  const initialFilters = {
    page: true,
    limit: 50,
    search: '',
    sort_by: 'created_at/-1',
    product_id: searchParams.get('id') || '',
  }

  const {filters, onSearch, onPageChange, setSingleFilter} = useFilters(initialFilters)
  const {data: response, isFetching} = Api.useGetQuery('/products/cost-analysis-report', {
    filters: filters,
  })

  const onSortingChange = (key: string, value: string) => {
    const direction = value === 'asc' ? 1 : -1
    const sortFlag = key + '/' + direction
    setSingleFilter('sort_by', sortFlag)
    setSingleFilter('page', 1)
  }

  return {
    costAnalysisReportList: dataToCostAnalysisReportList(response?.data || []),
    pagination: response?.pagination || {},
    isLoading: isFetching,
    filters,
    onSearch,
    onPageChange,
    onSortingChange,
  }
}

export default useGetCostAnalysisReportList
